import { useMutation } from '@tanstack/react-query'
import { useDispatch } from 'react-redux'
import { get_microsoft_user_id } from '../../../utils/conversion'
import {
  auth_finish_action,
  auth_login_success_action,
  auth_login_unauthorized_action,
  auth_start_login_request_action,
} from '../../../context/actions/auth_action'
import { LOGIN_UNAUTHORIZED } from '../../../data/system_settings'
import {
  showCredentialToast,
  showErrorToast,
  showLoadingToast,
  showSuccessToast,
} from '../../../utils/showToast'
import LoginServicer from '../../../service/LoginService'
import { accountService } from '../../../service/AccountService'

function AccountDTO(payload) {
  if (!payload || typeof payload !== 'object') {
    throw new Error('Invalid payload: Payload must be a non-null object.')
  }

  const accountData = payload.account || {}

  return {
    account: {
      uuid: accountData.uuid || 'N/A',
      id: accountData.id || 'N/A',
      name: accountData.name || 'N/A',
      accountType: accountData.accountType || 'unknown',
      course: accountData.course !== undefined ? accountData.course : 'N/A',
      groups: Array.isArray(accountData.groups) ? accountData.groups : [],
      schoolEmail: accountData.schoolEmail || 'N/A',
      personalEmail: accountData.personalEmail || 'N/A',
      phoneNumber: accountData.phoneNumber || 'N/A',
      className: accountData.className || 'N/A',
      faculty: accountData.faculty || 'N/A',
      school: accountData.school || 'N/A',
      devices: Array.isArray(accountData.devices) ? accountData.devices : [],
      books: Array.isArray(accountData.books) ? accountData.books : [],
      status: accountData.status || 'UNKNOWN',
      totalPayment:
        accountData.totalPayment !== undefined ? accountData.totalPayment : 0,
      joinDate: accountData.joinDate || 0,
    },
    uuid: payload.uuid || 'N/A',
    accessToken: payload.accessToken || 'N/A',
    publicKey: payload.publicKey || 'N/A',
    email: payload.email || 'N/A',
  }
}
export default function useLogin365Mutation() {
  const dispatch = useDispatch()

  const login365Mutation = useMutation({
    mutationFn: async ({ code, redirectUri }) => {
      const { success, message } = await LoginServicer.login365({
        code,
        redirectUri,
      })

      if (!success) throw new Error(message)
      const { accessToken, publicKey, email: resEmail, uuid } = message.content

      const { success: accountSuccess, message: accountMessage } =
        await accountService.getByUuid(uuid, accessToken)

      if (!accountSuccess) {
        throw new Error(message.content)
      }

      return AccountDTO({
        account: accountMessage.content,
        accessToken,
        message: resEmail,
        publicKey: publicKey,
      })
    },
    onMutate: () => {
      showLoadingToast('Đang đăng nhập Micorosoft 365...')
      dispatch(auth_start_login_request_action())
    },
    onSuccess: async (data) => {
      dispatch(auth_login_success_action(data))
      showSuccessToast('Đăng nhập thành công')
    },
    onError: (error) => {
      if (error.message.content === LOGIN_UNAUTHORIZED) {
        showCredentialToast('Bạn không có quyền truy cập')
        dispatch(auth_login_unauthorized_action())
      } else {
        showErrorToast({
          message: 'Đăng nhập thất bại',
          error: error.message.content || 'không xác định',
        })
      }
    },
    onSettled: () => {
      dispatch(auth_finish_action())
    },
  })

  return { login365Mutation }
}
